var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"actualites-page"}},[(_vm.showFournisseur)?_c('fournisseur-act'):_vm._e(),(_vm.showClient)?_c('actualites-clients'):_vm._e(),(_vm.showGestionnaire)?_c('actualites-admin'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }